import Icon from '@/components/ui/AppIcon';

interface ContactHeroProps {
  onEmergencyClick: () => void;
}

export default function ContactHero({ onEmergencyClick }: ContactHeroProps) {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-brand-primary py-20 lg:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(0,168,204,0.1),transparent_50%)]" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Emergency Badge */}
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-error/20 backdrop-blur-sm rounded-full border border-error/30 mb-6">
            <div className="w-2 h-2 bg-error rounded-full animate-pulse" />
            <span className="text-sm font-cta font-semibold text-white">24/7 Emergency Support Available</span>
          </div>

          {/* Main Heading */}
          <h1 className="font-headline font-bold text-4xl lg:text-5xl xl:text-6xl text-white mb-6 leading-tight">
            Let&apos;s Transform Your IT Infrastructure
          </h1>

          {/* Subheading */}
          <p className="font-body text-lg lg:text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Whether you need immediate emergency support or strategic IT planning, our expert team is ready to help. Get a free consultation and discover how we can optimize your technology investments.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onEmergencyClick}
              className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-4 bg-error hover:bg-error/90 text-white rounded-lg font-cta font-semibold text-base shadow-elevated hover:shadow-card transition-all duration-300 transform hover:scale-105"
            >
              <Icon name="ExclamationTriangleIcon" size={20} variant="solid" />
              <span>Emergency Support</span>
            </button>

            <a
              href="#consultation-form"
              className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-4 bg-white hover:bg-white/90 text-primary rounded-lg font-cta font-semibold text-base shadow-elevated hover:shadow-card transition-all duration-300 transform hover:scale-105"
            >
              <Icon name="CalendarIcon" size={20} variant="outline" />
              <span>Schedule Consultation</span>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 mt-12 pt-8 border-t border-white/20">
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={20} className="text-white/80" />
              <span className="text-sm font-body text-white/80">&lt;15 min response time</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ShieldCheckIcon" size={20} className="text-white/80" />
              <span className="text-sm font-body text-white/80">ISO 27001 Certified</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="UserGroupIcon" size={20} className="text-white/80" />
              <span className="text-sm font-body text-white/80">500+ Happy Clients</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}